export const DEAL_CAPITALIZATION_CATEGORY_SOURCES: string = 'sources';
export const DEAL_CAPITALIZATION_CATEGORY_USES: string = 'uses';
